import { RealtimeChatMessage } from '../../hooks/useRealtimeChat';

interface ChatMessageItemProps {
    message: RealtimeChatMessage;
    isOwnMessage: boolean;
    showHeader: boolean;
}

export function ChatMessageItem({ message, isOwnMessage, showHeader }: ChatMessageItemProps) {
    return (
        <div className={`flex mt-2 ${isOwnMessage ? 'justify-end' : 'justify-start'}`}>
            <div
                className={`max-w-[75%] w-fit flex flex-col gap-1 ${isOwnMessage ? 'items-end' : 'items-start'}`}
            >
                {showHeader && (
                    <div
                        className={`flex items-center gap-2 text-xs px-3 ${isOwnMessage ? 'justify-end flex-row-reverse' : ''}`}
                    >
                        <span className="font-medium text-gray-700 dark:text-gray-300">
                            {message.user.name}
                        </span>
                        <span className="text-gray-500 dark:text-gray-400 text-xs">
                            {new Date(message.createdAt).toLocaleTimeString('en-US', {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                            })}
                        </span>
                    </div>
                )}
                <div
                    className={`py-2 px-3 rounded-xl text-sm w-fit ${isOwnMessage
                            ? 'bg-rose-600 text-white'
                            : 'bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white'
                        }`}
                >
                    {message.content}
                </div>
            </div>
        </div>
    );
}
